var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sign-out-alt_1_",
    "data-name": "sign-out-alt(1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.624,
    height: 17.814,
    viewBox: "0 0 17.624 17.814",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M8.518,11.134a.742.742,0,0,0-.742.742V14.1a2.227,2.227,0,0,1-2.227,2.227H3.711A2.227,2.227,0,0,1,1.484,14.1V3.711A2.227,2.227,0,0,1,3.711,1.484H5.549A2.227,2.227,0,0,1,7.776,3.711V5.938a.742.742,0,0,0,1.484,0V3.711A3.716,3.716,0,0,0,5.549,0H3.711A3.716,3.716,0,0,0,0,3.711V14.1a3.716,3.716,0,0,0,3.711,3.711H5.549A3.716,3.716,0,0,0,9.26,14.1V11.876A.742.742,0,0,0,8.518,11.134Z",
    fill: "#082654"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M18.262,8.621l-3.4-3.4a.742.742,0,1,0-1.05,1.05l3.164,3.164L5.742,9.453a.742.742,0,0,0,0,1.484h0l11.273-.023-3.209,3.209a.742.742,0,1,0,1.05,1.05l3.4-3.4a2.227,2.227,0,0,0,0-3.149Z",
    transform: "translate(-1.289 -1.289)",
    fill: "#082654"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logoutIcon.a461d084f931fef691bcc255bafa556f.svg";
export { ForwardRef as ReactComponent };